{
  "modal_message": "Avez-vous l’application Gucci?",
  "modal_yes": "OUI",
  "modal_no": "NON"
}
